<template>
  <popup :close-action="this.closeModal">
    <div class="padding-m ri-title" style="text-align: right">
      המערכת מעבירה אותך לאתר הבנק לביצוע ההעברה. אחרי האישור נשלח לך את קוד השובר.
      <riseup-button title="קחו אותי לבנק" :action="redirectToBank" class="margin-top-m" />
    </div>

  </popup>
</template>
<script>

import { mapActions } from 'vuex';
import Segment from '@/Segment';
import BaseUI from '@riseupil/base-ui';
import router from '@/router';

export default {
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    redirectUrl: { type: String, required: true },
  },
  created() {
    Segment.trackUserGot('RamiLevi_SuperDiscount_Popup_Entered');
  },
  methods: {
    ...mapActions('modalRootStore', ['closeModal']),
    async redirectToBank() {
      Segment.trackUserInteraction('RamiLevi_SuperDiscount_Popup_RedirectingToBank_clicked');
      window.open(this.redirectUrl, '_blank');
      await this.closeModal();
      await router.push({ name: 'SuperDiscountV2' });
    },
  },
};
</script>
